var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", { ref: "provider-general-info-form" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("div", { staticClass: "col" }, [
          _c("label", [_vm._v("SSN Patronal:")]),
          _c("p", [_vm._v(_vm._s(_vm.providerInfo.ssn))])
        ]),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("validation-provider", {
              attrs: {
                "custom-messages": { required: "Campo Requerido" },
                rules: !_vm.disabled ? "required" : null
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-drop-down", {
                        attrs: {
                          clearable: false,
                          "custom-error-msg": errors[0],
                          disabled:
                            (_vm.providerInfo.primaryProvider.ssn != null ||
                              _vm.proposalInfo != null ||
                              _vm.disabled) &&
                            !_vm.isDirectPay,
                          error: errors[0],
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Tipo de Proveedor:",
                          options: _vm.companyTypesOptions
                        },
                        model: {
                          value: _vm.model.type,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "type", $$v)
                          },
                          expression: "model.type"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("validation-provider", {
              attrs: {
                "custom-messages": { required: "Campo Requerido" },
                rules: !_vm.disabled ? "required" : null
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("div", { staticClass: "color-gray-6 font-14 mb-2" }, [
                        _vm._v("Nombre:")
                      ]),
                      _c("custom-input", {
                        class: {
                          "ml-n3": _vm.proposalInfo != null
                        },
                        attrs: {
                          "custom-error-msg": errors[0],
                          disabled: _vm.proposalInfo != null || _vm.disabled,
                          error: errors[0]
                        },
                        model: {
                          value: _vm.model.name,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "name", $$v)
                          },
                          expression: "model.name"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm.providerInfo.primaryProvider.ssn === null
          ? [
              _c("section-title", {
                staticClass: "col-12 mt-2 mb-2",
                attrs: { "has-line": false, title: "Información General" }
              }),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("validation-provider", {
                    attrs: {
                      "custom-messages": { required: "Campo Requerido" },
                      rules: !_vm.disabled ? "url" : null
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  "custom-error-msg": errors[0],
                                  disabled: _vm.disabled,
                                  error: errors[0],
                                  label: "Dirección Web:",
                                  placeholder: "www.websitedomain.com"
                                },
                                model: {
                                  value: _vm.model.website,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "website", $$v)
                                  },
                                  expression: "model.website"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4268051394
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("validation-provider", {
                    attrs: {
                      "custom-messages": { required: "Campo Requerido" },
                      rules: !_vm.disabled ? "required" : null
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  "custom-error-msg": errors[0],
                                  disabled: _vm.disabled,
                                  error: errors[0],
                                  label: "Teléfono:",
                                  "mask-type": "Phone",
                                  placeholder: "(___) ___-____"
                                },
                                model: {
                                  value: _vm.model.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "phone", $$v)
                                  },
                                  expression: "model.phone"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3778808429
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("custom-input", {
                    attrs: {
                      disabled: _vm.disabled,
                      label: "Fax:",
                      "mask-type": "Phone",
                      placeholder: "(___) ___-____"
                    },
                    model: {
                      value: _vm.model.fax,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "fax", $$v)
                      },
                      expression: "model.fax"
                    }
                  })
                ],
                1
              ),
              !_vm.isIndividualCompany
                ? _c(
                    "div",
                    { staticClass: "col-sm" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-radio", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Este campo es requerido",
                                      error: errors[0],
                                      "is-inline": "",
                                      label: "Tipo de Proveedor:",
                                      name: "profitType",
                                      options: _vm.profitTypeOptions
                                    },
                                    model: {
                                      value: _vm.model.profitType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "profitType", $$v)
                                      },
                                      expression: "model.profitType"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2504461620
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-sm" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  "custom-error-msg": errors[0],
                                  error: errors[0],
                                  label: "Número de RUP:",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.model.rupNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "rupNumber", $$v)
                                  },
                                  expression: "model.rupNumber"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      131692711
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm" },
                [
                  _c("validation-provider", {
                    attrs: {
                      "custom-messages": { required: "Campo Requerido" },
                      rules: !_vm.disabled ? "required" : null
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  "custom-error-msg": errors[0],
                                  disabled: _vm.disabled,
                                  error: errors[0],
                                  label: "Registro del Departamento de Estado:",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.model.stateDeptRegistration,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "stateDeptRegistration",
                                      $$v
                                    )
                                  },
                                  expression: "model.stateDeptRegistration"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2974181948
                    )
                  })
                ],
                1
              )
            ]
          : _vm._e(),
        _vm.providerInfo.primaryProvider.ssn != null
          ? [
              _c("div", { staticClass: "col-12 d-flex flex-column mt-3" }, [
                _c("strong", [_vm._v(" Compañía Primaria: ")]),
                _c("span", { staticClass: "font-weight-normal" }, [
                  _vm._v(
                    " " + _vm._s(_vm.providerInfo.primaryProvider.name) + " "
                  )
                ])
              ])
            ]
          : _vm._e()
      ],
      2
    ),
    _vm.providerInfo.primaryProvider.ssn === null && _vm.isIndividualCompany
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-input", {
                            attrs: {
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label: "Especialidad:",
                              maxlength: "100"
                            },
                            model: {
                              value: _vm.model.specialty,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "specialty", $$v)
                              },
                              expression: "model.specialty"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1406474630
                )
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-input", {
                            attrs: {
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label: "Número de Licencia:",
                              maxlength: "50"
                            },
                            model: {
                              value: _vm.model.licenseNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "licenseNumber", $$v)
                              },
                              expression: "model.licenseNumber"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3309433772
                )
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }